import {
  getEndOfDayInUTC,
  getStartOfDayInUTC,
} from "../helpers/getUTCDateTime";
import { successHandling } from "../helpers/successHandling";
import { phpRequest } from "./phpRequest";

export const renewSubscribeServiceAPI = async (
  t,
  setDialogOpen,
  serviceId,
  users,
  startedAt,
  endedAt
) => {
  const userJsons = users.map((o) => ({
    id: o.id,
    company_id: o.origin.company_id,
    name: o.name,
    email: o.origin.email,
  }));
  const successfulText = "subscribeNewService.successfullyRenewSubscription";

  const data = await phpRequest.post("/subscribe/renewal", {
    subscribe_value_added_service_id: serviceId,
    users: JSON.stringify(userJsons),
    started_at: getStartOfDayInUTC(startedAt),
    ended_at: getEndOfDayInUTC(endedAt),
  });
  successHandling(t, successfulText, "success");
  setDialogOpen(true);
  return data.subscription;
};
